export function extractErrorMessage(err: any): string {
  const rawDetail =
    err?.response?.data?.detail ||
    err?.detail ||
    err?.message ||
    "Unknown error";

  // Handle FastAPI validation error arrays (422 errors)
  if (Array.isArray(rawDetail)) {
    return rawDetail
      .map((e: any) => e.msg || e.message || "Validation error")
      .join("; ");
  }

  // Handle objects (including single validation errors)
  if (typeof rawDetail === "object" && rawDetail !== null) {
    return rawDetail.msg || rawDetail.message || "An error occurred";
  }

  // Handle strings with embedded JSON
  if (typeof rawDetail === "string") {
    try {
      const match = rawDetail.match(/{.*}/);
      if (match) {
        return JSON.parse(match[0]).detail || rawDetail;
      }
    } catch {
      // Not JSON, return as-is
    }
    return rawDetail;
  }

  // Fallback: always return a string
  return "An error occurred";
}

export function extractApiError(err: any): string {
  const error = err as {
    response?: { data?: { error?: string; endpoint?: string } };
    message?: string;
  };
  const apiError = error.response?.data?.error;
  const endpoint = error.response?.data?.endpoint;
  const description =
    apiError && endpoint
      ? `${apiError} — ${endpoint}`
      : apiError || error.message || "An unexpected error occurred";
  return description;
}
